export const dashboardStats = {
  totalRevenue: 142500,
  totalRevenueChange: 12.5,
  totalOrders: 1250,
  totalOrdersChange: 8.3,
  totalCustomers: 3400,
  totalCustomersChange: 15.2,
  totalProducts: 256,
  totalProductsChange: 5.1,
};

export const products = [
  {
    id: 1,
    name: 'Premium Leather Sofa',
    sku: 'SOFA-001',
    category: 'Sofas',
    price: 45000,
    discountPrice: 39500,
    stock: 25,
    status: 'active',
    rating: 4.8,
    reviews: 124,
    image: 'https://via.placeholder.com/150',
    material: 'Premium Leather',
    dimensions: '220cm x 90cm x 85cm',
    color: 'Charcoal Black',
    description: 'Luxurious seating experience with premium Italian leather.',
  },
  {
    id: 2,
    name: 'Modern Dining Table',
    sku: 'TABLE-001',
    category: 'Dining Tables',
    price: 28000,
    discountPrice: 24500,
    stock: 12,
    status: 'active',
    rating: 4.5,
    reviews: 87,
    image: 'https://via.placeholder.com/150',
    material: 'Solid Oak Wood',
    dimensions: '180cm x 90cm x 75cm',
    color: 'Natural Wood',
    description: 'Elegant solid wood dining table with premium finish.',
  },
  {
    id: 3,
    name: 'Contemporary Bed Frame',
    sku: 'BED-001',
    category: 'Beds',
    price: 35000,
    discountPrice: 31500,
    stock: 18,
    status: 'active',
    rating: 4.7,
    reviews: 156,
    image: 'https://via.placeholder.com/150',
    material: 'Metal + Upholstery',
    dimensions: '200cm x 160cm x 100cm',
    color: 'Grey',
    description: 'Modern bed frame with upholstered headboard.',
  },
  {
    id: 4,
    name: 'Executive Office Chair',
    sku: 'CHAIR-001',
    category: 'Office Furniture',
    price: 12500,
    discountPrice: 11000,
    stock: 8,
    status: 'active',
    rating: 4.4,
    reviews: 62,
    image: 'https://via.placeholder.com/150',
    material: 'Leather + Mesh',
    dimensions: '70cm x 70cm x 120cm',
    color: 'Black',
    description: 'Ergonomic office chair with premium materials.',
  },
  {
    id: 5,
    name: 'Wooden Wardrobe Cabinet',
    sku: 'WARDROBE-001',
    category: 'Wardrobes',
    price: 32000,
    discountPrice: 28500,
    stock: 6,
    status: 'low_stock',
    rating: 4.6,
    reviews: 98,
    image: 'https://via.placeholder.com/150',
    material: 'Plywood with Veneer',
    dimensions: '200cm x 60cm x 220cm',
    color: 'Walnut Brown',
    description: 'Spacious wardrobe with mirror and internal storage.',
  },
  {
    id: 6,
    name: 'Accent Armchair',
    sku: 'CHAIR-002',
    category: 'Chairs',
    price: 15000,
    discountPrice: 13200,
    stock: 3,
    status: 'low_stock',
    rating: 4.3,
    reviews: 45,
    image: 'https://via.placeholder.com/150',
    material: 'Fabric Upholstery',
    dimensions: '85cm x 80cm x 95cm',
    color: 'Beige',
    description: 'Stylish accent chair perfect for any room.',
  },
];

export const orders = [
  {
    id: 'ORD-001',
    customerName: 'John Doe',
    email: 'john@example.com',
    amount: 95500,
    status: 'delivered',
    paymentStatus: 'paid',
    date: '2024-01-15',
    items: 3,
    shippingAddress: '123 Main St, City, State 12345',
    trackingNumber: 'TRACK-123456789',
  },
  {
    id: 'ORD-002',
    customerName: 'Sarah Johnson',
    email: 'sarah@example.com',
    amount: 52000,
    status: 'shipped',
    paymentStatus: 'paid',
    date: '2024-01-18',
    items: 2,
    shippingAddress: '456 Oak Ave, City, State 12346',
    trackingNumber: 'TRACK-987654321',
  },
  {
    id: 'ORD-003',
    customerName: 'Michael Chen',
    email: 'michael@example.com',
    amount: 78500,
    status: 'processing',
    paymentStatus: 'pending',
    date: '2024-01-20',
    items: 4,
    shippingAddress: '789 Pine Rd, City, State 12347',
    trackingNumber: null,
  },
  {
    id: 'ORD-004',
    customerName: 'Emily Wilson',
    email: 'emily@example.com',
    amount: 125000,
    status: 'delivered',
    paymentStatus: 'paid',
    date: '2024-01-10',
    items: 5,
    shippingAddress: '321 Elm St, City, State 12348',
    trackingNumber: 'TRACK-555666777',
  },
  {
    id: 'ORD-005',
    customerName: 'David Brown',
    email: 'david@example.com',
    amount: 45000,
    status: 'pending',
    paymentStatus: 'pending',
    date: '2024-01-22',
    items: 1,
    shippingAddress: '654 Maple Dr, City, State 12349',
    trackingNumber: null,
  },
];

export const customers = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    phone: '+1-555-0101',
    orders: 5,
    totalSpend: 325000,
    status: 'active',
    joinDate: '2023-06-15',
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    email: 'sarah@example.com',
    phone: '+1-555-0102',
    orders: 3,
    totalSpend: 156000,
    status: 'active',
    joinDate: '2023-08-22',
  },
  {
    id: 3,
    name: 'Michael Chen',
    email: 'michael@example.com',
    phone: '+1-555-0103',
    orders: 8,
    totalSpend: 456000,
    status: 'vip',
    joinDate: '2023-03-10',
  },
  {
    id: 4,
    name: 'Emily Wilson',
    email: 'emily@example.com',
    phone: '+1-555-0104',
    orders: 2,
    totalSpend: 145000,
    status: 'active',
    joinDate: '2023-11-05',
  },
  {
    id: 5,
    name: 'David Brown',
    email: 'david@example.com',
    phone: '+1-555-0105',
    orders: 1,
    totalSpend: 45000,
    status: 'active',
    joinDate: '2024-01-15',
  },
];

export const reviews = [
  {
    id: 1,
    productId: 1,
    productName: 'Premium Leather Sofa',
    customerName: 'John Doe',
    rating: 5,
    review: 'Absolutely amazing quality and comfort!',
    date: '2024-01-20',
    status: 'approved',
  },
  {
    id: 2,
    productId: 2,
    productName: 'Modern Dining Table',
    customerName: 'Sarah Johnson',
    rating: 4,
    review: 'Great table, very sturdy construction.',
    date: '2024-01-18',
    status: 'approved',
  },
  {
    id: 3,
    productId: 3,
    productName: 'Contemporary Bed Frame',
    customerName: 'Michael Chen',
    rating: 5,
    review: 'Perfect for modern bedrooms. Highly recommended.',
    date: '2024-01-22',
    status: 'pending',
  },
];

export const analyticsData = {
  monthlySales: [
    { month: 'Jan', sales: 45000, revenue: 425000 },
    { month: 'Feb', sales: 52000, revenue: 480000 },
    { month: 'Mar', sales: 48000, revenue: 450000 },
    { month: 'Apr', sales: 61000, revenue: 580000 },
    { month: 'May', sales: 55000, revenue: 520000 },
    { month: 'Jun', sales: 67000, revenue: 630000 },
  ],
  orderStatus: [
    { name: 'Delivered', value: 650 },
    { name: 'Shipped', value: 280 },
    { name: 'Processing', value: 150 },
    { name: 'Pending', value: 45 },
    { name: 'Cancelled', value: 25 },
  ],
  categoryRevenue: [
    { category: 'Sofas', revenue: 185000 },
    { category: 'Beds', revenue: 145000 },
    { category: 'Dining Tables', revenue: 125000 },
    { category: 'Office Furniture', revenue: 95000 },
    { category: 'Wardrobes', revenue: 110000 },
  ],
  customerGrowth: [
    { month: 'Jan', customers: 800 },
    { month: 'Feb', customers: 950 },
    { month: 'Mar', customers: 1100 },
    { month: 'Apr', customers: 1350 },
    { month: 'May', customers: 1600 },
    { month: 'Jun', customers: 2100 },
  ],
};

export const lowStockProducts = [
  { id: 5, name: 'Wooden Wardrobe Cabinet', stock: 6, threshold: 10 },
  { id: 6, name: 'Accent Armchair', stock: 3, threshold: 10 },
  { id: 1, name: 'Premium Leather Sofa', stock: 2, threshold: 5 },
];

export const categories = [
  { id: 1, name: 'Sofas', productCount: 45, image: 'https://via.placeholder.com/150' },
  { id: 2, name: 'Beds', productCount: 38, image: 'https://via.placeholder.com/150' },
  { id: 3, name: 'Dining Tables', productCount: 29, image: 'https://via.placeholder.com/150' },
  { id: 4, name: 'Chairs', productCount: 52, image: 'https://via.placeholder.com/150' },
  { id: 5, name: 'Wardrobes', productCount: 18, image: 'https://via.placeholder.com/150' },
  { id: 6, name: 'Office Furniture', productCount: 34, image: 'https://via.placeholder.com/150' },
];

export const coupons = [
  { id: 1, code: 'SAVE20', discount: 20, type: 'percentage', maxUses: 100, used: 45, expiryDate: '2024-12-31', status: 'active' },
  { id: 2, code: 'FREESHIP', discount: 500, type: 'fixed', maxUses: 200, used: 120, expiryDate: '2024-12-15', status: 'active' },
  { id: 3, code: 'WINTER10', discount: 10, type: 'percentage', maxUses: 50, used: 50, expiryDate: '2024-02-28', status: 'expired' },
];

export const banners = [
  {
    id: 1,
    title: 'Winter Sale',
    description: 'Up to 40% off on selected furniture',
    image: 'https://via.placeholder.com/1200x300',
    link: '/shop?category=sofas',
    status: 'active',
    startDate: '2024-01-01',
    endDate: '2024-02-29',
  },
  {
    id: 2,
    title: 'New Arrivals',
    description: 'Check out our latest furniture collection',
    image: 'https://via.placeholder.com/1200x300',
    link: '/shop?sort=newest',
    status: 'active',
    startDate: '2024-01-10',
    endDate: '2024-03-31',
  },
];

export const activityLogs = [
  { id: 1, action: 'Product Added', detail: 'Premium Leather Sofa added to catalog', user: 'Admin', timestamp: '2024-01-22 10:30:00' },
  { id: 2, action: 'Order Shipped', detail: 'Order ORD-002 marked as shipped', user: 'Admin', timestamp: '2024-01-22 09:15:00' },
  { id: 3, action: 'Customer Registered', detail: 'New customer David Brown registered', user: 'System', timestamp: '2024-01-22 08:45:00' },
  { id: 4, action: 'Review Approved', detail: 'Customer review approved', user: 'Moderator', timestamp: '2024-01-22 07:20:00' },
  { id: 5, action: 'Coupon Created', detail: 'New coupon SAVE20 created', user: 'Admin', timestamp: '2024-01-21 16:30:00' },
];

export const recentOrdersForDashboard = orders.slice(0, 5);

export const topProductsForDashboard = products.slice(0, 5).map(p => ({
  ...p,
  salesThisMonth: Math.floor(Math.random() * 150) + 20,
}));
